import { defineMessages } from 'react-intl';

export const deviceSetupAwarenessCardMessages = defineMessages({
  ariaLabel: {
    defaultMessage: 'Dictaphone detected',
    description: 'Accessible label for the dictaphone device setup awareness card',
    id: 'LMJPsLNHQm',
  },
  title: {
    defaultMessage: 'Your dictaphone works with Heidi!',
    description:
      'Title on the awareness card shown when a supported USB dictaphone is connected',
    id: 'YzjQzcuTZc',
  },
  body: {
    defaultMessage: 'Hold the record button to dictate into Heidi or any other app.',
    description:
      'Supporting copy on the awareness card shown when a supported USB dictaphone is connected',
    id: 'naDsPb6O3S',
  },
  gotIt: {
    defaultMessage: 'Got it',
    description: 'Primary action dismissing the dictaphone detected awareness card',
    id: 'kIgaFSuvCi',
  },
  setupBody: {
    defaultMessage: 'Set up now to dictate into Heidi or any other app.',
    description: 'Supporting copy on the awareness card when device setup is available',
    id: 'g9dZbg6Grt',
  },
  later: {
    defaultMessage: 'Later',
    description: 'Secondary action dismissing the awareness card without starting setup',
    id: 'GxoAgHvXMr',
  },
  setUpNow: {
    defaultMessage: 'Set up now',
    description: 'Primary action opening the add-device dialog from the awareness card',
    id: 'c6orjq+fKY',
  },
  close: {
    defaultMessage: 'Close',
    description:
      'Accessible label for the close button on the dictaphone setup awareness card',
    id: '035VxvFJaz',
  },
});

export const dictaphoneConnectedToastMessages = defineMessages({
  title: {
    defaultMessage: 'Dictaphone connected',
    id: '0tAJ01H4wf',
    description:
      'Toast title confirming a supported USB dictaphone was plugged in and is ready to use',
  },
  doublePressBody: {
    defaultMessage: 'Hold {button} to dictate, or press it twice for hands-free.',
    id: 'JQt+qWVuvw',
    description:
      'Toast body under "Dictaphone connected" when hands-free starts on a double press; {button} is the device button that dictates, e.g. "Record"',
  },
  singlePressBody: {
    defaultMessage: 'Hold {button} to dictate, or press it once for hands-free.',
    id: 'RBIOLmboKc',
    description:
      'Toast body under "Dictaphone connected" when hands-free starts on a single press; {button} is the device button that dictates, e.g. "Record"',
  },
  noTriggerBody: {
    defaultMessage: 'No button is set to start dictation. Change this in Settings.',
    id: '/IGx9xRHh4',
    description:
      'Toast body under "Dictaphone connected" when the user mapped the record button to another action and no button starts dictation',
  },
});
